module.exports = __webpack_public_path__ + "static/media/p2008man.bcded8ae.jpg";